<!--
 * @Description: 报名审核 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.auditStatus"
        placeholder="审核状态"
      >
        <el-option
          v-for="(item, i) in auditStatusAttr"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="姓名"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";

export default {
  name: "search",
  components: { butn },
  data() {
    return {
      filters: {},
      auditStatusAttr: [],
    };
  },
  created() {
    this.getSysParam();
  },
  methods: {
    // 获取数据字典
    getSysParam() {
      getDataMap("AUDIT_STATUS").then((res) => {
        if (res.code !== 0) return;
        res.data.splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.auditStatusAttr = res.data.slice(0, 4);
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {};
      this.initData();
    },
  },
};
</script>
